
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from '@/components/ui/toaster';

// Import existing pages that are already in the codebase
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Clubs from './pages/Clubs';
import ClubDetails from './pages/ClubDetails';
import Opportunities from './pages/Opportunities';
import Events from './pages/Events';
import Mentors from './pages/Mentors';
import Explore from './pages/Explore';
import Index from './pages/Index'; // Import the Index page
import Auth from './pages/Auth'; // Import the Auth page
import Privacy from './pages/Privacy'; // Import the Privacy page
import Terms from './pages/Terms'; // Import the Terms page
import BecomeMentor from './pages/BecomeMentor'; // Import the BecomeMentor page
import ProtectedRoute from './components/ProtectedRoute'; // Import the ProtectedRoute component
import PitchPlayground from './pages/PitchPlayground'; // Import the new PitchPlayground page

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Index />} /> {/* Set Index as the default landing page */}
          <Route path="/auth" element={<Auth />} />
          <Route path="/privacy" element={<Privacy />} /> {/* Add route for Privacy Policy */}
          <Route path="/terms" element={<Terms />} /> {/* Add route for Terms of Service */}
          
          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile/:userId" element={<Profile />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/clubs" element={<Clubs />} />
            <Route path="/clubs/:clubId" element={<ClubDetails />} />
            <Route path="/clubs/:clubId/threads/:threadId" element={<ClubDetails />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/events" element={<Events />} />
            <Route path="/mentors" element={<Mentors />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/become-mentor" element={<BecomeMentor />} />
            <Route path="/pitch-playground" element={<PitchPlayground />} /> {/* Add route for PitchPlayground */}
          </Route>
        </Routes>
        
        <Toaster />
      </Router>
    </AuthProvider>
  );
}

export default App;
